<h1 mat-dialog-title>
	<span i18n>Edit</span> <small class="align-top">- {{dialogData.appkey.name}} <span
		class="badge badge-pill badge-secondary provider-badge ml-2 text-capitalize {{ dialogData.appkey.provider != 'local' ? 'badge-' + dialogData.appkey.provider : '' }}"
		matTooltip="Provider"
		i18n-matTooltip
	>{{dialogData.appkey.provider}}</span></small>

	<button type="button" mat-icon-button [matMenuTriggerFor]="appKeyMenu" class="app-key-menu-btn">
		<span class="material-icons">more_vert</span>
	</button>
	<mat-menu #appKeyMenu="matMenu" xPosition="before">
		<div class="top-right-drop-menu">
			<button mat-menu-item (click)="openAction(appKeyTableActions.legals)">
				<div class="row px-2">
					<div class="col pl-2"><span>Edit Legals</span></div>
				</div>
			</button>
			<button mat-menu-item (click)="openAction(appKeyTableActions.requiredVersions)">
				<div class="row px-2">
					<div class="col pl-2"><span>View Required Versions</span></div>
				</div>
			</button>
		</div>
	</mat-menu>
</h1>

<div mat-dialog-content class="main-content">
	<div class="row">
		<div class="col">
			<app-appkey-edit-form
				[appKey]="dialogData.appkey"
				[company]="dialogData.company"
				[cluster]="dialogData.cluster"
				[(unsavedChanges)]="unsavedChanges"
				(closed)="handleEvent($event.appKey)"
				(cancelled)="handleEvent($event.appKey)"
				(updated)="handleEvent($event.appKey)"
			></app-appkey-edit-form>
		</div>
	</div>
</div>
